
import { IBenchmarkEvaluation, IBenchmarkEvaluationData, IBenchmarkParams, IBenchmarkEvaluationStats, ITableRes } from 'types'
import { baseApi } from './baseApi'

export const benchmarkEvaluationsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_benchmarkEvaluations: builder.query<ITableRes<IBenchmarkEvaluation>, IBenchmarkParams>({
      query: (params) => ({
        url: '/benchmark-evaluations/',
        params,
      }),
      providesTags: ['benchmark-evaluations'],
    }),
    GET_benchmarkEvaluationById: builder.query<IBenchmarkEvaluation, string>({
      query: (id) => {
        return {
          url: `benchmark-evaluations/${id}/`,
        }
      },
      providesTags: ['benchmark-evaluations'],
    }),
    POST_benchmarkEvaluation: builder.mutation<IBenchmarkEvaluation, IBenchmarkEvaluationData>({
      query: (body) => ({
        url: `/benchmark-evaluations/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['benchmark-evaluations'],
    }),
    PATCH_benchmarkEvaluation: builder.mutation<IBenchmarkEvaluation, { id: string; body: IBenchmarkEvaluationData }>({
      query: ({ id, body }) => ({
        url: `/benchmark-evaluations/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['benchmark-evaluations'],
    }),
    GET_benchmarkEvaluationStats: builder.query<IBenchmarkEvaluationStats[], IBenchmarkParams>({
      query: (params) => ({
        url: '/benchmark-evaluations/stats/',
        params
      }),
      providesTags: ['benchmark-evaluations'],
    }),
  }),

})

export const { 
  useGET_benchmarkEvaluationsQuery,
  useGET_benchmarkEvaluationByIdQuery,
  usePOST_benchmarkEvaluationMutation, 
  usePATCH_benchmarkEvaluationMutation, 
  useGET_benchmarkEvaluationStatsQuery,
} = benchmarkEvaluationsAPI
